import { createRequest, RequestConfig } from 'app/common/api';

import { TTariffTypesConstraints } from '../core/tariff-types-constraints';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/get_tariff_types',
};

export const getTariffTypesRequest = (constraints?: TTariffTypesConstraints) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(constraints),
  });
